module.exports = __webpack_public_path__ + "img/warning.e985ba20.svg";